import { render, staticRenderFns } from "./extraInfo.vue?vue&type=template&id=2d4d6ea9&"
import script from "./extraInfo.vue.ts?vue&type=script&lang=ts&"
export * from "./extraInfo.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports